import config from "@/config";

/**********************************************************************************************/
/****************TODO: Performance improvement*************************************************/
/****************Since, some function need to trigger the component function*******************/
/****************Some code has been combined into components to prevent infinity loop**********/
/**********************************************************************************************/

let functions = {
  addDetailClick(e) {
    let $btnAddDetail = $(e.currentTarget);
    let tableName = $btnAddDetail.attr("fbtablename");
    let formStructure = this.formStructure;

    for (const tempTableKey in formStructure) {
      if (tableName == tempTableKey) {
        let tempColumns = formStructure[tempTableKey];
        let tempObj = {};
        for (const tempColumnKey in formStructure[tempTableKey]) {
          if (
            formStructure[tempTableKey][tempColumnKey].datatype ==
            "files"
          )
            tempObj[
              formStructure[tempTableKey][tempColumnKey].column_name
            ] = [];
          else
            tempObj[
              formStructure[tempTableKey][tempColumnKey].column_name
            ] = null;
        }

        //tempObj.id = '00000000-0000-0000-0000-000000000000';
        tempObj.id = this.$helper.genUUID();
        tempObj.isNew = 1;
        tempObj.attachmentList = [];
        this.formData[tableName].push(tempObj);
        break;
      }
    }
  },

  removeDetailClick(e, idx) {
    let $btnRemoveDetail = $(e.currentTarget);
    let tableName = $btnRemoveDetail.attr("fbtablename");
    if (this.isEdit) {
      this.formData[tableName].splice(idx, 1);
    }
  },

  sum(tbl_col_array) {
    //TODO: Handle more cases (Not only 1 main => n sub / 1 sub => n sub)
    // [main.a, sub1.a, sub2.c ...]
    let data = this.formData; // {mainXXXXXXXXXXX: {}, subXXXXXXXXXXXXXXXXX: {}, subXXXXXXXXX: {}}
    let return_value = 0;
    let target_table_res = tbl_col_array[0].split("."); //retrive result column's table name, column from array
    let target_table = target_table_res[0];
    let target_column = target_table_res[1];
    let index = 0;

    for (var tbl_col_s_key in tbl_col_array) {
      if (index == 0) {
        let target_tbl_col_res = tbl_col_array[tbl_col_s_key].split(
          "."
        ); //GET target table
        target_table = target_tbl_col_res[0];
        target_column = target_tbl_col_res[1];
      } else {
        if (target_table.substring(35,target_table.length).startsWith("main")) {
          //GET changing table (target table is main), 1 Main, N Sub
          var tbl_col_s = tbl_col_array[tbl_col_s_key];
          var tbl_col_res = tbl_col_s.split(".");
          var tbl_name = tbl_col_res[0];
          var col_name = tbl_col_res[1];
          if (tbl_name.substring(35,tbl_name.length).startsWith("main")) {
            if (!isNaN(data[tbl_name][col_name]))
              return_value += parseFloat(data[tbl_name][col_name]);
            else return_value += 0;
          } else {
            for (let i = 0; i < data[tbl_name].length; i++) {
              if (!isNaN(data[tbl_name][i][col_name]))
                return_value += parseFloat(
                  data[tbl_name][i][col_name]
                );
              else return_value += 0;
            }
          }
        } else {
          //GET changing table (target table is sub), N Sub
          var tbl_col_s = tbl_col_array[tbl_col_s_key];
          var tbl_col_res = tbl_col_s.split(".");
          var tbl_name = tbl_col_res[0];
          var col_name = tbl_col_res[1];
          let numOfDetailTable = data[target_table].length;
          for (let j = 0; j < numOfDetailTable; j++) {
            // Each Detail Table
            for (let k = 1; k < tbl_col_array.length; k++) {
              //Calculate all column
              var tbl_col_s = tbl_col_array[k];
              var tbl_col_res = tbl_col_s.split(".");
              var tbl_name = tbl_col_res[0];
              var col_name = tbl_col_res[1];

              if (!isNaN(data[tbl_name][j][col_name]))
                return_value += parseFloat(
                  data[tbl_name][j][col_name]
                );
              else return_value += 0;
            }
            data[target_table][j][
              target_column
            ] = return_value.toFixed(2);
            return_value = 0;
          }
        }
      }
      index++;
    }
    if (target_table.substring(35,target_table.length).startsWith("main")) {
      data[target_table][target_column] = return_value.toFixed(2);
      return return_value;
    }
  },

  difference(tbl_col_array){
    let data = this.formData; // {mainXXXXXXXXXXX: {}, subXXXXXXXXXXXXXXXXX: {}, subXXXXXXXXX: {}}
    let target_table_res = tbl_col_array[0].split("."); //retrive result column's table name, column from array
    let target_table = target_table_res[0];
    let target_column = target_table_res[1];
    let type = tbl_col_array.pop();
    let index = 0;
    let return_value = 0;

    if(type != 'sequential'){
      var temp = tbl_col_array.shift();
      tbl_col_array = tbl_col_array.reverse();
      tbl_col_array.unshift(temp);
    }

    let first_changing_table = tbl_col_array[1].split(".")[0];
    let first_changing_column = tbl_col_array[1].split(".")[1];

    for (var tbl_col_s_key in tbl_col_array) {
      if (index == 0) {
        let target_tbl_col_res = tbl_col_array[tbl_col_s_key].split(
          "."
        ); //GET target table
        target_table = target_tbl_col_res[0];
        target_column = target_tbl_col_res[1];
      } else {
        if (target_table.substring(35,target_table.length).startsWith("main")) {
          //GET changing table (target table is main), 1 Main, N Sub
          var tbl_col_s = tbl_col_array[tbl_col_s_key];
          var tbl_col_res = tbl_col_s.split(".");
          var tbl_name = tbl_col_res[0];
          var col_name = tbl_col_res[1];

          if (tbl_name.substring(35,tbl_name.length).startsWith("main")) {
            if (!isNaN(data[tbl_name][col_name]))
              return_value -= parseFloat(data[tbl_name][col_name]);
            else return_value -= 0;
          } else {
            for (let i = 0; i < data[tbl_name].length; i++) {
              if (!isNaN(data[tbl_name][i][col_name]))
                return_value -= parseFloat(
                  data[tbl_name][i][col_name]
                );
              else return_value -= 0;
            }
          }
        } else {
          //GET changing table (target table is sub), N Sub
          var tbl_col_s = tbl_col_array[tbl_col_s_key];
          var tbl_col_res = tbl_col_s.split(".");
          var tbl_name = tbl_col_res[0];
          var col_name = tbl_col_res[1];
          let numOfDetailTable = data[target_table].length;
          for (let j = 0; j < numOfDetailTable; j++) {
            // Each Detail Table
            if (!isNaN(data[tbl_name][j][col_name]))
              return_value = parseFloat(data[first_changing_table][j][first_changing_column]) * 2;

            for (let k = 1; k < tbl_col_array.length; k++) {
              //Calculate all column
              var tbl_col_s = tbl_col_array[k];
              var tbl_col_res = tbl_col_s.split(".");
              var tbl_name = tbl_col_res[0];
              var col_name = tbl_col_res[1];

              if (!isNaN(data[tbl_name][j][col_name]))
                return_value -= parseFloat(data[tbl_name][j][col_name]);
              else return_value -= 0;
            }

            data[target_table][j][target_column] = return_value.toFixed(2);
            return_value = 0;
          }
        }
      }
      index++;
    }
    if (target_table.substring(35,target_table.length).startsWith("main")) {
      return_value += parseFloat(data[first_changing_table][first_changing_column]) * 2;
      data[target_table][target_column] = return_value.toFixed(2);
      return return_value;
    }

  },

  count(tbl_col_array) {
    var data = this.formData;
    let target_maintable = tbl_col_array[0].split(".")[0]; //maintable
    let target_column = tbl_col_array[0].split(".")[1];

    let target_subtable = tbl_col_array[1].split(".")[0]; //subtable

    let return_value = data[target_subtable].length;
    data[target_maintable][target_column] = return_value;
    return return_value;
  },

  multiplication(tbl_col_array){
    var data = this.formData;

    if(tbl_col_array.length == 3){ //target + changing + multiplication
      let target_table = tbl_col_array[0].split(".")[0]; //maintable
      let target_column = tbl_col_array[0].split(".")[1];

      let changing_table = tbl_col_array[1].split(".")[0]; //subtable
      let changing_column = tbl_col_array[1].split(".")[1];

      let multiply = tbl_col_array[2];//multiplication

      for (let i = 0; i < data[changing_table].length; i++) {
        var value =
          data[changing_table][i][changing_column] * multiply;
        data[target_table][i][target_column] = value.toFixed(2);
      }
    }else{
      console.log('MULTIPLICATION do not have 3 parameters');
    }
  },

  percentage(tbl_col_array) {
    var data = this.formData;

    if(tbl_col_array.length == 3){ //target + changing + percentage
      let target_table = tbl_col_array[0].split(".")[0]; //maintable
      let target_column = tbl_col_array[0].split(".")[1];

      let changing_table = tbl_col_array[1].split(".")[0]; //subtable
      let changing_column = tbl_col_array[1].split(".")[1];

      let percentage = tbl_col_array[2];//percentage


        for (let i = 0; i < data[changing_table].length; i++) {
          let value = data[changing_table][i][changing_column];
          if(value){
            value = value * (percentage / 100);
            data[target_table][i][target_column] = value.toFixed(2);
          }
      }
    }else{
      console.log('PERCENTAGE do not have 3 parameters');
    }
  },
  gst(tbl_col_array) {
    var data = this.formData;
    var optionData = this.optionData;
    if(tbl_col_array.length == 3){ //target + changing + gst
      let target_table = tbl_col_array[0].split(".")[0]; //maintable
      let target_column = tbl_col_array[0].split(".")[1];

      let changing_table = tbl_col_array[1].split(".")[0]; //subtable
      let changing_column = tbl_col_array[1].split(".")[1];

      let gst_table = tbl_col_array[2].split(".")[0];
      let gst_column = tbl_col_array[2].split(".")[1];


        for (let i = 0; i < data[changing_table].length; i++) {
          let value = data[changing_table][i][changing_column];
          if(value){
            let value2 = data[gst_table][i][gst_column];
            var value3;
            if(value2!=undefined){
            value3 = optionData[gst_table][gst_column][value2];
            }else{
              value3=0;
            }
            value = value * (value3 / 100);
            data[target_table][i][target_column] = value.toFixed(2);
          }
      }
    }else{
      console.log('gst do not have 3 parameters');
    }
  },
  ocr(tbl_col_array) {
    var data = this.formData;
    if(tbl_col_array.length <= 3){ //target + date + amount
      let target_table = tbl_col_array[0].split(".")[0]; //maintable
      let target_column = tbl_col_array[0].split(".")[1];
      if(tbl_col_array.length>=2){
      let date_table = tbl_col_array[1].split(".")[0]; //subtable
      let date_column = tbl_col_array[1].split(".")[1];
      }
      if(tbl_col_array.length==3){
      let amount_table = tbl_col_array[2].split(".")[0];
      let amount_column = tbl_col_array[2].split(".")[1];
      }

       
    }else{
    }
  },
  dateDifference(tbl_col_array) {
    var data = this.formData;
    let return_value = 1;
    let target_table = tbl_col_array[0].split(".")[0];
    let target_column = tbl_col_array[0].split(".")[1];
    let temp = []; //temporarily store the date
    var components = this;

    function countWeekend(date1, date2) {
      var d1 = new Date(date1),
        d2 = new Date(date2),
        isWeekend = false,
        num = 0;

      while (d1 < d2) {
        var day = d1.getDay();
        isWeekend = day == 6 || day == 0;
        if (isWeekend) {
          num++;
        }
        d1.setDate(d1.getDate() + 1);
      }
      return num;
    }

    for (let i = 1; i < tbl_col_array.length; i++) {
      let temp_changing_table = tbl_col_array[i].split(".")[0];
      let temp_changing_column = tbl_col_array[i].split(".")[1];
      if (data[temp_changing_table][temp_changing_column]) {
        temp.push(data[temp_changing_table][temp_changing_column]);
      }
    }

    if (temp.length == 2) {
      let a = moment(temp[0], ['DD/MM/YYYY', 'YYYY-MM-DD']);
      let b = moment(temp[1], ['DD/MM/YYYY', 'YYYY-MM-DD']);
      let dayDifference = b.diff(a, "days", true);
      var changing_old_value;

      return_value = dayDifference - countWeekend(a, b) + 1;
      return_value = Math.abs(return_value);

      let changing_column = tbl_col_array[2].split(".")[1];
      let changing_table_less = tbl_col_array[2].split(".")[0].split('_')[0];
      let changing_table = tbl_col_array[2].split(".")[0];

      $.each(components.$children, function(key, component){
        if(component.$vnode.data.attrs.column_name == changing_column && component.$vnode.data.attrs.mb_form_table_type == changing_table_less){ //$vnode.data wouldn't trigger infinity loop, but $attrs will
        changing_old_value = moment(component.value, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY');
      }
      });

      if(this.$children.length > 0){
        if(data[changing_table][changing_column] != changing_old_value){
          data[target_table][target_column] = return_value;
        }
      }
    }
  },

  postcode(tbl_col_array) {
    var data = this.formData;
    let return_value = 0;
    let target_table = tbl_col_array[1].split(".")[0];
    let target_column = tbl_col_array[1].split(".")[1];

    let changing_table = tbl_col_array[0].split(".")[0];
    let changing_column = tbl_col_array[0].split(".")[1];

    let country = tbl_col_array[2];

    if(tbl_col_array.length == 3){
      let param = [];

      if (data[changing_table][changing_column] != null) {
        param = data[changing_table][changing_column].split(',');

        var request = JSON.stringify({
          SessionID: this.$store.state.token,
          LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            locality: param[0],
            state: param[1].trim(),
            country: country
          },
          ApiKey: config.apiKey,
          ApiSystemName: config.apiSystemName
        });
        setTimeout(function () {
          $.ajax({
            url: config.serverURI + "/api/userBuildForm/getPostCode",
            type: "post",
            dataType: "json",
            data: request,
            headers: {
              "Content-type": "application/json; charset=utf-8"
            },
            success: function (res) {
              data[target_table][target_column] = res.data.postcode;
            }
          });
        }, 150);
      }
    }
  },

  startFromDate(tbl_col_array) {
    //Changing the target_column value => so that the function.js startFromDate's WATCH VALUE can rerender the component
    var data = this.formData;
    let  target_table = tbl_col_array[0].split(".")[0];
    let  target_column = tbl_col_array[0].split(".")[1];
    let target_table_less = target_table.split('_')[0]; // main || sub

    let changing_table = tbl_col_array[1].split(".")[0];
    let changing_column = tbl_col_array[1].split(".")[1];
    let changing_table_less = changing_table.split('_')[0]; //main || sub

    var components = this;
    var target_old_value;
    var changing_old_value;

    if(components.$children.length > 0){ //precent haven't mounted
      $.each(components.$children, function(key, component){
        if(component.$vnode.data.attrs.column_name == changing_column && component.$vnode.data.attrs.mb_form_table_type == changing_table_less){ //$vnode.data wouldn't trigger infinity loop, but $attrs will
          changing_old_value = moment(component.value,['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY');
        }
      });

      if(changing_old_value != data[changing_table][changing_column]){
        data[target_table][target_column] = data[changing_table][changing_column]
      }
    }
  },



}



export default functions;

